// Google PageSpeed Insights API key (optional).
//
// Leave '' to run keyless — this WORKS, but Google rate-limits anonymous calls to
// a few requests per minute, so under load some audits will fail with a 429.
//
// For production, create a FREE key (no billing required):
//   Google Cloud Console → APIs & Services → enable "PageSpeed Insights API"
//   → Credentials → Create API key → paste it below.
// Then optionally restrict the key to the PageSpeed Insights API + your domain.
export const PAGESPEED_API_KEY = 'AIzaSyAlO__dY2pfxtoYa5SqyjK5043lxmRk6dQ';
